import { GeomapService } from "./geomapService.js"
import { GeomapUtil } from "./geomapUtil.js"
import QuickInfo, { QuickInfoStatistic } from "../core/components/quickInfo.js";
import { WaypointType, WaypointData } from "./components/directions/waypoint.js";
import { Helper } from "../core/util/helper.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";
export class Cartographer {
    private _googleDirectionsDisplay: google.maps.DirectionsRenderer;
    private _directionsRenderers: Array<google.maps.DirectionsRenderer> = [];
    private _infoWindow: google.maps.InfoWindow;
    private _markerClusterers: Array<RouteClusterer> = [];
    private _searchClusterer: MarkerClusterer;
    private _highlightedPath: google.maps.Polyline;
    private _highlightedMarkerCircle: google.maps.Marker;
    pinConfig: Array<PinTypeConfig>;
    map: google.maps.Map;
    lat: number;
    lng: number;
    geomapService: GeomapService;
    geomapUtil: GeomapUtil;
    circle: google.maps.Circle;
    markers: Array<google.maps.Marker> = [];
    minimumClusterSize: number = 5;
    clusterGridSize: number = 50;

    constructor(map: google.maps.Map) {
        this.map = map;
        this._googleDirectionsDisplay = new google.maps.DirectionsRenderer();
        this._googleDirectionsDisplay.setMap(this.map);
        this._googleDirectionsDisplay.setOptions({ suppressMarkers: true } as google.maps.DirectionsRendererOptions);
        this.geomapService = new GeomapService();
        this.geomapUtil = GeomapUtil.getInstance();
        this._searchClusterer = this._createClusterer(null);
    }

    private _routeIdExists = (routeId: number) => {
        return this._directionsRenderers.filter((r) => {
            if (r.get("routeId") === routeId) {
                return true;
            }
            return false;
        }).length > 0;
    }


    private _createIconDiv = (waypointType: WaypointType, routeId: number, useTempCoordinates?: boolean) => {
        const color = this.geomapUtil.getColor(routeId);
        let svgHtml;
        switch (waypointType) {
            case WaypointType.ADDRESS:
                svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M570.6 244C577.2 249.8 577.8 259.1 571.1 266.6C566.2 273.2 556 273.8 549.4 267.1L512 234.1V432C512 476.2 476.2 512 432 512H144C99.82 512 64 476.2 64 432V234.1L26.59 267.1C19.96 273.8 9.849 273.2 4.003 266.6C-1.844 259.1-1.212 249.8 5.414 244L277.4 4.002C283.5-1.334 292.5-1.334 298.6 4.002L570.6 244zM144 480H208V320C208 302.3 222.3 288 240 288H336C353.7 288 368 302.3 368 320V480H432C458.5 480 480 458.5 480 432V206.7L288 37.34L96 206.7V432C96 458.5 117.5 480 144 480zM240 480H336V320H240V480z" transform="translate(55 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-home"></i> -->`;
                break;
            case WaypointType.MACHINE:
                svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M103.1 176C103.1 145.1 129.1 120 159.1 120C190.9 120 215.1 145.1 215.1 176C215.1 206.9 190.9 232 159.1 232C129.1 232 103.1 206.9 103.1 176zM159.1 152C146.7 152 135.1 162.7 135.1 176C135.1 189.3 146.7 200 159.1 200C173.3 200 183.1 189.3 183.1 176C183.1 162.7 173.3 152 159.1 152zM213.9 51.16C223.4 55.3 232.4 60.5 240.6 66.61L267.7 58.52C273.2 56.85 279.3 58.3 283.3 62.62C299.5 80.44 311.9 101.8 319.3 125.4C321.1 130.9 319.3 136.9 315.1 140.9L294.1 160C295.7 165.5 295.1 171.1 295.1 176.8C295.1 181.1 295.7 187.1 295.2 192.1L315.1 211.1C319.3 215.1 321.1 221.1 319.3 226.6C311.9 250.2 299.5 271.6 283.3 289.4C279.3 293.7 273.2 295.2 267.7 293.5L242.1 285.8C233.3 292.5 223.7 298.1 213.5 302.6L207.3 328.6C205.1 334.3 201.7 338.8 196 340.1C184.4 342.6 172.4 344 159.1 344C147.6 344 135.6 342.6 123.1 340.1C118.3 338.8 114 334.3 112.7 328.6L106.5 302.6C96.26 298.1 86.67 292.5 77.91 285.8L52.34 293.5C46.75 295.2 40.65 293.7 36.73 289.4C20.5 271.6 8.055 250.2 .6513 226.6C-1.078 221.1 .6929 215.1 4.879 211.1L24.85 192.1C24.29 187.1 24 181.1 24 176.8C24 171.1 24.34 165.5 25.01 160L4.879 140.9C.6936 136.9-1.077 130.9 .652 125.4C8.056 101.8 20.51 80.44 36.73 62.62C40.65 58.3 46.75 56.85 52.34 58.52L79.38 66.61C87.62 60.5 96.57 55.3 106.1 51.17L112.7 23.36C114 17.71 118.3 13.17 123.1 11.91C135.6 9.35 147.6 8 159.1 8C172.4 8 184.4 9.35 196 11.91C201.7 13.16 205.1 17.71 207.3 23.36L213.9 51.16zM58.71 147.9L56.78 163.9C56.26 168.1 55.1 172.4 55.1 176.8C55.1 180.8 56.22 184.7 56.65 188.6L58.4 204.4L34.72 226.9C39.47 238.8 45.84 249.8 53.55 259.7L84.35 250.5L97.31 260.4C104 265.5 111.4 269.8 119.2 273.2L133.9 279.5L141.3 310.7C147.4 311.6 153.6 312 159.1 312C166.3 312 172.6 311.6 178.7 310.7L186.1 279.5L200.8 273.2C208.6 269.8 215.1 265.5 222.7 260.4L235.7 250.5L266.4 259.7C274.2 249.8 280.5 238.8 285.3 226.9L261.6 204.4L263.3 188.6C263.8 184.7 263.1 180.8 263.1 176.8C263.1 172.4 263.7 168.1 263.2 163.9L261.3 147.9L285.3 125.1C280.5 113.2 274.2 102.2 266.4 92.29L234.4 101.9L221.6 92.32C215.2 87.64 208.4 83.67 201.1 80.51L186.5 74.13L178.7 41.29C172.6 40.44 166.3 40 159.1 40C153.6 40 147.4 40.44 141.3 41.29L133.5 74.13L118.8 80.51C111.6 83.67 104.7 87.64 98.44 92.32L85.56 101.9L53.55 92.29C45.84 102.2 39.47 113.2 34.72 125.1L58.71 147.9zM464 296C494.9 296 520 321.1 520 352C520 382.9 494.9 408 464 408C433.1 408 408 382.9 408 352C408 321.1 433.1 296 464 296V296zM488 352C488 338.7 477.3 328 464 328C450.7 328 440 338.7 440 352C440 365.3 450.7 376 464 376C477.3 376 488 365.3 488 352zM588.8 405.9C584.7 415.4 579.5 424.4 573.4 432.6L581.5 459.7C583.2 465.2 581.7 471.3 577.4 475.3C559.6 491.5 538.2 503.9 514.6 511.3C509.1 513.1 503.1 511.3 499.1 507.1L479.1 486.1C474.5 487.7 468.9 488 463.2 488C458 488 452.9 487.7 447.9 487.2L428.9 507.1C424.9 511.3 418.9 513.1 413.4 511.3C389.8 503.9 368.4 491.5 350.6 475.3C346.3 471.4 344.9 465.2 346.5 459.7L354.2 434.1C347.5 425.3 341.9 415.7 337.4 405.5L311.4 399.3C305.7 397.1 301.2 393.7 299.9 388C297.4 376.4 296 364.4 296 352C296 339.6 297.4 327.6 299.9 315.1C301.2 310.3 305.7 306 311.4 304.7L337.4 298.5C341.9 288.3 347.5 278.7 354.2 269.9L346.5 244.3C344.9 238.8 346.3 232.7 350.6 228.7C368.4 212.5 389.8 200.1 413.4 192.7C418.9 190.9 424.9 192.7 428.9 196.9L447.9 216.9C452.9 216.3 458 216 463.2 216C468.9 216 474.5 216.3 479.1 217L499.1 196.9C503.1 192.7 509.1 190.9 514.6 192.7C538.2 200.1 559.6 212.5 577.4 228.7C581.7 232.7 583.2 238.8 581.5 244.3L573.4 271.4C579.5 279.6 584.7 288.6 588.8 298.1L616.6 304.7C622.3 306 626.8 310.3 628.1 315.1C630.7 327.6 632 339.6 632 352C632 364.4 630.7 376.4 628.1 388C626.8 393.7 622.3 397.1 616.6 399.3L588.8 405.9zM492.1 250.7L476.1 248.8C471.9 248.3 467.6 248 463.2 248C459.2 248 455.3 248.2 451.4 248.7L435.6 250.4L413.1 226.7C401.2 231.5 390.2 237.8 380.3 245.6L389.5 276.4L379.6 289.3C374.5 296 370.2 303.4 366.8 311.2L360.5 325.9L329.3 333.3C328.4 339.4 328 345.7 328 352C328 358.3 328.4 364.6 329.3 370.7L360.5 378.1L366.8 392.8C370.2 400.6 374.5 407.1 379.6 414.7L389.5 427.7L380.3 458.4C390.2 466.2 401.2 472.5 413.1 477.3L435.6 453.6L451.4 455.4C455.3 455.8 459.2 456 463.2 456C467.6 456 471.9 455.7 476.1 455.2L492.1 453.3L514.9 477.3C526.8 472.5 537.8 466.2 547.7 458.4L538.1 426.4L547.7 413.6C552.4 407.3 556.3 400.4 559.5 393.1L565.9 378.5L598.7 370.7C599.6 364.6 600 358.3 600 352C600 345.7 599.6 339.4 598.7 333.3L565.9 325.5L559.5 310.9C556.3 303.6 552.4 296.8 547.7 290.4L538.1 277.6L547.7 245.6C537.8 237.8 526.8 231.5 514.9 226.7L492.1 250.7z" transform="translate(45 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-cogs"></i> -->`;
                break;
            case WaypointType.RESOURCE:
                if (Helper.hasValue(useTempCoordinates) && useTempCoordinates)
                    svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M80 296C80 282.7 90.75 272 104 272C117.3 272 128 282.7 128 296C128 309.3 117.3 320 104 320C90.75 320 80 309.3 80 296zM432 296C432 309.3 421.3 320 408 320C394.7 320 384 309.3 384 296C384 282.7 394.7 272 408 272C421.3 272 432 282.7 432 296zM48.29 204.7L82.99 89.01C93.14 55.17 124.3 32 159.6 32H352.4C387.7 32 418.9 55.17 429 89.01L463.7 204.7C492.6 221.2 512 252.3 512 288V464C512 472.8 504.8 480 496 480C487.2 480 480 472.8 480 464V416H32V464C32 472.8 24.84 480 16 480C7.164 480 0 472.8 0 464V288C0 252.3 19.44 221.2 48.29 204.7zM85.33 192.6C88.83 192.2 92.39 192 96 192H416C419.6 192 423.2 192.2 426.7 192.6L398.4 98.21C392.3 77.9 373.6 64 352.4 64H159.6C138.4 64 119.7 77.9 113.6 98.21L85.33 192.6zM32 288V384H480V288C480 260.3 462.4 236.7 437.7 227.8L437.3 227.9L437.2 227.6C430.5 225.3 423.4 224 416 224H96C88.58 224 81.46 225.3 74.83 227.6L74.73 227.9L74.27 227.8C49.62 236.7 32 260.3 32 288V288z" transform="translate(60 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-car"></i> -->`;
                else
                    svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M224 64C224 99.35 195.3 128 159.1 128C124.7 128 95.1 99.35 95.1 64C95.1 28.65 124.7 0 159.1 0C195.3 0 224 28.65 224 64zM159.1 32C142.3 32 127.1 46.33 127.1 64C127.1 81.67 142.3 96 159.1 96C177.7 96 192 81.67 192 64C192 46.33 177.7 32 159.1 32zM29.64 312.4C25.02 319.9 15.17 322.3 7.637 317.6C.1046 313-2.257 303.2 2.363 295.6L46.62 223.5C70.8 184 113.7 159.1 160 159.1C206.3 159.1 249.2 184 273.4 223.5L317.6 295.6C322.3 303.2 319.9 313 312.4 317.6C304.8 322.3 294.1 319.9 290.4 312.4L246.1 240.2C244.2 237.1 242.2 234.2 239.1 231.3V496C239.1 504.8 232.8 512 223.1 512C215.2 512 207.1 504.8 207.1 496V384H112V496C112 504.8 104.8 512 96 512C87.17 512 80 504.8 80 496V231.3C77.82 234.2 75.79 237.1 73.9 240.2L29.64 312.4zM207.1 352V204.1C193.5 196.3 177 192 160 192C142.1 192 126.5 196.3 112 204.1V352H207.1z" transform="translate(80 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-child"></i> -->`;
                break;
            case WaypointType.ASSIGNMENT:
                svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M219.3 395.3C213.1 401.6 202.9 401.6 196.7 395.3L132.7 331.3C126.4 325.1 126.4 314.9 132.7 308.7C138.9 302.4 149.1 302.4 155.3 308.7L208 361.4L308.7 260.7C314.9 254.4 325.1 254.4 331.3 260.7C337.6 266.9 337.6 277.1 331.3 283.3L219.3 395.3zM128 64H320V16C320 7.164 327.2 0 336 0C344.8 0 352 7.164 352 16V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H96V16C96 7.164 103.2 0 112 0C120.8 0 128 7.164 128 16V64zM32 448C32 465.7 46.33 480 64 480H384C401.7 480 416 465.7 416 448V192H32V448zM32 128V160H416V128C416 110.3 401.7 96 384 96H64C46.33 96 32 110.3 32 128z" transform="translate(70 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-calendar-check"></i> -->`;
                break;
            case WaypointType.TICKET:
                svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 304c8.844 0 16-7.156 16-16V128c0-8.844-7.156-16-16-16S240 119.2 240 128v160C240 296.8 247.2 304 256 304zM256 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S269.3 344 256 344z" transform="translate(65 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-exclamation-circle"></i> -->`;
                break;
            default:
                svgHtml = `<svg class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="" style="color:${color}"><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path><path fill="white" d="M570.6 244C577.2 249.8 577.8 259.1 571.1 266.6C566.2 273.2 556 273.8 549.4 267.1L512 234.1V432C512 476.2 476.2 512 432 512H144C99.82 512 64 476.2 64 432V234.1L26.59 267.1C19.96 273.8 9.849 273.2 4.003 266.6C-1.844 259.1-1.212 249.8 5.414 244L277.4 4.002C283.5-1.334 292.5-1.334 298.6 4.002L570.6 244zM144 480H208V320C208 302.3 222.3 288 240 288H336C353.7 288 368 302.3 368 320V480H432C458.5 480 480 458.5 480 432V206.7L288 37.34L96 206.7V432C96 458.5 117.5 480 144 480zM240 480H336V320H240V480z" transform="translate(55 55) scale(0.5)"></path></svg><!-- <i class="fa fa-map-marker"></i> --><!-- <i class="fal fa-home"></i> -->`;
                break;
        }
        let icon = {
            scaledSize: new google.maps.Size(35, 35),
            url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgHtml),
            labelOrigin: new google.maps.Point(0, 35)
        } as google.maps.Icon;
        return icon;
    }


    private _getPinConfigForType = (pinType: WaypointType) => {
        let config = this.pinConfig.filter((pc) => {
            return pc.type.toLowerCase() === WaypointType[pinType].toLowerCase();
        });
        return config[0];
    }

    private _removeQuickInfoComponent = (marker: google.maps.Marker) => {
        let element = marker.get("infoWindowElement");
        if (element) {
            ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(element).parentElement);
            marker.set("infoWindowElement", null);
        }

    }

    private _renderQuickInfo = (marker: google.maps.Marker, guid: string, entity: Object, pinConfig: PinTypeConfig, infoWindow: google.maps.InfoWindow) => {
        window.requestAnimationFrame(() => {
            const element = document.getElementById(guid);
            if (element) {
                ReactDOM.render(<QuickInfo ref={(r) => {
                    marker.set("infoWindowElement", r);
                }} entity={entity} dynamicApi={pinConfig.props.dynamicApi} statistics={pinConfig.props.statistics} template={pinConfig.props.template} />, element);
            }
        });
    }

    private _addMarkerToMarkerClusterer = (marker: google.maps.Marker) => {
        const routeId = marker.get("routeId");
        if (routeId != null) {
            let routeClusterer = this._markerClusterers.filter((mc) => {
                return mc.routeId === routeId;
            })[0];

            if (routeClusterer) {
                routeClusterer.clusterer.addMarker(marker);
            }
            else {
                const markerClusterer = this._createClusterer(routeId);
                markerClusterer.addMarker(marker);
                this._markerClusterers.push({ routeId: routeId, clusterer: markerClusterer } as RouteClusterer);
            }
        }
        else {
            this._searchClusterer.addMarker(marker);
        }
    }

    private _createClusterer = (routeId: number) => {
        let svgOuterDiv = document.getElementById("clusterMarkerElement");
        if (svgOuterDiv) {
            const color = this.geomapUtil.getColor(routeId);
            const styleValue = `color:${color}`;
            const svg1 = `<svg style="${styleValue}" class="svg-inline--fa fa-location-pin" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-pin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z"></path></svg>`;
            let encoded = window.btoa(svg1);

            const clusterStyles = [
                {
                    width: 40,
                    height: 55,
                    anchorText: [-10, 0],
                    url: 'data:image/svg+xml;base64,' + encoded,
                    textColor: 'black',
                    textSize: 12
                },
                {
                    width: 50,
                    height: 70,
                    anchorText: [-10, 0],
                    url: 'data:image/svg+xml;base64,' + encoded,
                    textColor: 'black',
                    textSize: 14
                },
                {
                    width: 60,
                    height: 80,
                    anchorText: [-10, 0],
                    url: 'data:image/svg+xml;base64,' + encoded,
                    textColor: 'black',
                    textSize: 16
                }
            ] as ClusterIconStyle[];

            return new MarkerClusterer(this.map, null, { minimumClusterSize: this.minimumClusterSize, gridSize: this.clusterGridSize, styles: clusterStyles, ignoreHidden: true } as MarkerClustererOptions);
        }
    }

    private _removeMarkerFromMarkerClusterer = (marker: google.maps.Marker) => {
        const routeId = marker.get("routeId");
        if (routeId != null) {
            let routeClusterer = this._markerClusterers.filter((mc) => {
                return mc.routeId === routeId;
            })[0];

            if (routeClusterer) {
                routeClusterer.clusterer.removeMarker(marker);
                if (routeClusterer.clusterer.getTotalMarkers() === 0) {
                    this._markerClusterers = this._markerClusterers.filter((mc) => {
                        return mc.routeId !== routeId;
                    });
                }
            }
        }
        else {
            this._searchClusterer.removeMarker(marker);
        }
    }

    private _removeMultipleMarkersFromClusterer = (markers: Array<google.maps.Marker>, routeId: number) => {
        if (routeId != null) {
            let routeClusterer = this._markerClusterers.filter((mc) => {
                return mc.routeId === routeId;
            })[0];

            if (routeClusterer) {
                routeClusterer.clusterer.removeMarkers(markers);
                if (routeClusterer.clusterer.getTotalMarkers() === 0) {
                    this._markerClusterers = this._markerClusterers.filter((mc) => {
                        return mc.routeId !== routeId;
                    });
                }
            }
        }
        else {
            this._searchClusterer.removeMarkers(markers);
        }
    }

    private _clickInfoWindowHandler = (marker: google.maps.Marker, entity: Object, template: string, guid: string, infowindow: google.maps.InfoWindow, pinConfig: PinTypeConfig) => {
        infowindow.open(this.map, marker);
        if (pinConfig) {
            this._renderQuickInfo(marker, guid, entity, pinConfig, infowindow);
        }
    }

    setZoom = (level: number) => {
        this.map.setZoom(level);
    }

    panTo = (lat: number, lng: number) => {
        this.map.panTo(new google.maps.LatLng(lat, lng));
    }

    //Geocoding
    setMarker = (geojsonFeature: any, showInfoWindow: boolean = false, mapCreated: boolean = false) => {
        let marker = new google.maps.Marker({
            map: this.map,
            draggable: false,
            title: "Lat: " + geojsonFeature.geometry.coordinates[1] + " Lng: " + geojsonFeature.geometry.coordinates[0],
            position: { lat: geojsonFeature.geometry.coordinates[1], lng: geojsonFeature.geometry.coordinates[0] }
        });

        marker.set("id", kendo.guid());
        let template = this.getTemplate(geojsonFeature);
        let pinConfig = this._getPinConfigForType(WaypointType.GEOCODEPIN);

        marker.addListener("click", () => {
            if (pinConfig && !marker.get("infoWindowElement")) {
                let guid = kendo.guid();
                this._infoWindow = new google.maps.InfoWindow({
                    content: pinConfig ? `<div id=${guid}></div>` : template
                });
                this._infoWindow.open(this.map, marker);
                this._renderQuickInfo(marker, guid, geojsonFeature, pinConfig, this._infoWindow);
            }
            else {
                this._infoWindow.open(this.map, marker);
            }
        });
        this.markers.push(marker);
        if (mapCreated) {
            google.maps.event.addListenerOnce(this.map, "tilesloaded", () => {
                if (pinConfig && !marker.get("infoWindowElement")) {
                    let guid = kendo.guid();
                    this._infoWindow = new google.maps.InfoWindow({
                        content: pinConfig ? `<div id=${guid}></div>` : template
                    });
                    this._infoWindow.open(this.map, marker);
                    this._renderQuickInfo(marker, guid, geojsonFeature, pinConfig, this._infoWindow);
                }
                else {
                    this._infoWindow.open(this.map, marker);
                }
            });
        }

        if (showInfoWindow) {
            if (pinConfig && !marker.get("infoWindowElement")) {
                let guid = kendo.guid();
                this._infoWindow = new google.maps.InfoWindow({
                    content: pinConfig ? `<div id=${guid}></div>` : template
                });
                this._infoWindow.open(this.map, marker);
                this._renderQuickInfo(marker, guid, geojsonFeature, pinConfig, this._infoWindow);
            }
            else {
                this._infoWindow.open(this.map, marker);
            }
        }
    }

    //Directions
    setMarkerByType = (waypoint: WaypointData, routeId: number, clickCallback?: (...args: any[]) => void) => {
        let geojsonFeature = {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [(waypoint.lng || 0), (waypoint.lat || 0)]
            },
            properties: {
                adrnr: (waypoint.no || null),
                name: (waypoint.name || null),
                address: (waypoint.address || null),
                description: (waypoint.description || null)
            }
        };

        let marker = new google.maps.Marker({
            optimized: false,
            draggable: false,
            icon: this._createIconDiv(waypoint.waypointType, routeId, waypoint.useTempCoordinates),
            title: "Lat: " + geojsonFeature.geometry.coordinates[1] + " Lng: " + geojsonFeature.geometry.coordinates[0],
            position: { lat: geojsonFeature.geometry.coordinates[1], lng: geojsonFeature.geometry.coordinates[0] }
        });

        marker.set("id", kendo.guid());
        marker.set("routeId", routeId);
        let template = this.getTemplate(geojsonFeature);

        this._addMarkerToMarkerClusterer(marker);

        let guid = kendo.guid();
        let pinConfig = this._getPinConfigForType(waypoint.waypointType);
        let infoWindow = new google.maps.InfoWindow({
            content: pinConfig ? `<div id=${guid}></div>` : template
        });

        if (typeof clickCallback === "function") {
            marker.addListener("click", (e: any) => { clickCallback(e, marker) });
        }
        else {
            marker.addListener("click", () => {
                google.maps.event.clearListeners(marker, "mouseout");
                google.maps.event.clearListeners(marker, "mouseover");
            });
        }

        const quickInfoEntity = waypoint.waypointType === WaypointType.COORDINATEPIN ? geojsonFeature : waypoint.entity;

        if (waypoint.waypointType !== WaypointType.COORDINATEPIN && waypoint.waypointType == WaypointType.MACHINE && quickInfoEntity["usemaschlocation"] === true) {
            quickInfoEntity["adrnr"] = undefined;
            quickInfoEntity["adrname"] = "Lat: " + quickInfoEntity["breitegrad"] + " Lng: " + quickInfoEntity["laengegrad"];
            quickInfoEntity["strasse"] = undefined;
            quickInfoEntity["plz"] = undefined;
            quickInfoEntity["ort"] = undefined;
        }

        marker.addListener("mouseover", () => { this._clickInfoWindowHandler(marker, quickInfoEntity, template, guid, infoWindow, pinConfig) });

        marker.addListener("mouseout", () => {
            this._removeQuickInfoComponent(marker);
            infoWindow.close();
        });

        infoWindow.addListener("closeclick", () => {
            if (typeof clickCallback !== "function") {
                marker.addListener("mouseover", () => { this._clickInfoWindowHandler(marker, quickInfoEntity, template, guid, infoWindow, pinConfig) });
                marker.addListener("mouseout", () => {
                    this._removeQuickInfoComponent(marker);
                    infoWindow.close();
                });
            }
            this._removeQuickInfoComponent(marker);
        });

        this.togglePins(routeId, true);
        this.markers.push(marker);
        waypoint.markerId = marker.get("id");
    }

    setMarkerAndUpdateLocation = (geojsonFeature: any, showInfoWindow: boolean = false, mapCreated: boolean = false) => {
        this.removeAllMarkers();
        this.map.panTo(new google.maps.LatLng(geojsonFeature.geometry.coordinates[1], geojsonFeature.geometry.coordinates[0]));
        this.setMarker(geojsonFeature, showInfoWindow, mapCreated);
    }

    setFocusToMarker = (lat: number, lng: number) => {
        this.map.panTo(new google.maps.LatLng(lat, lng));
    }

    removeMarker = (id: string) => {
        this.markers = this.markers.filter((m) => {
            if (m.get("id") === id) {
                this._removeQuickInfoComponent(m);
                m.setMap(null);
                this._removeMarkerFromMarkerClusterer(m);
                return false;
            }
            return true;
        });
    }

    removeAllMarkers = () => {
        this._markerClusterers.forEach((mc) => {
            mc.clusterer.clearMarkers();
        });
        for (var i = 0; i < this.markers.length; i++) {
            this._removeQuickInfoComponent(this.markers[i]);
            this.markers[i].setMap(null);
        }
        this.markers = [];
    }

    getTemplate = (geojsonFeature: any) => {
        let idLine = (geojsonFeature.properties.adrnr || geojsonFeature.properties.name) ? '<b>ID: ' + (geojsonFeature.properties.adrnr || "") + ' ' + (geojsonFeature.properties.name || "") + '</b><br/>' : "";
        let addressLine = geojsonFeature.properties.address ? '<b>Adr.:</b> ' + geojsonFeature.properties.address + '<br/>' : "";
        let template =
            '<div style = "white-space: nowrap">' +
            idLine +
            addressLine +
            '<b>Lat.:</b> ' + (geojsonFeature.geometry.coordinates[1] || "") + '<br/>' +
            '<b>Lng.:</b> ' + (geojsonFeature.geometry.coordinates[0] || "") + '</div>';
        return template;
    }

    geocode = (address: string) => {
        return this.geomapService.googleGeoCode(address);
    }

    drawRoute = (points: Array<any>) => {
        return this.geomapService.googleRoute(points, false);
    }

    optimize = (points: Array<any>) => {
        return this.geomapService.googleRoute(points, true);
    }

    createRoutingLayer = (result: google.maps.DirectionsResult, routeId: number) => {
        if (this._routeIdExists(routeId)) {
            this.removeRoutingLayer(routeId);
        }
        let renderer = new google.maps.DirectionsRenderer();
        this._directionsRenderers.push(renderer);
        let color = this.geomapUtil.getColor(routeId);
        renderer.set("routeId", routeId);
        renderer.set("color", color);
        renderer.setMap(this.map);
        renderer.setOptions({
            suppressMarkers: true,
            polylineOptions: {
                strokeColor: color
            } as google.maps.PolylineOptions
        } as google.maps.DirectionsRendererOptions);
        renderer.setDirections(result);

        return renderer;
    }

    removeRoutingLayer = (routeId: number) => {
        this._directionsRenderers = this._directionsRenderers.filter((r) => {
            if (routeId === r.get("routeId")) {
                r.setMap(null);
                return false;
            }
            else {
                return true;
            }
        });
    }

    removeAllRoutingLayers = () => {
        this._directionsRenderers.forEach((r) => {
            r.setMap(null);
        });
        this._directionsRenderers = [];
    }

    //ToDo:Styling

    private _getMarker(markerId) {
        return this.markers.filter((m) => {
            if (markerId === m.get("id")) {
                return true;
            }
            return false;
        });
    }

    addNumbersToMarkers = (waypoints: Array<WaypointData>, reorderedPoints?: Array<number>) => {
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

        for (let i = 0; i < waypoints.length; i++) {
            let index: number;
            if (reorderedPoints && (i !== 0 && i !== (waypoints.length - 1))) {
                index = reorderedPoints[i - 1] + 1;
            }
            else {
                index = i;
            }
            let marker = this._getMarker(waypoints[index].markerId);
            marker[0].setLabel({ text: labels[i], fontSize: "25px", fontWeight: "bold" } as google.maps.MarkerLabel);
        }

        for (let i = 0; i < waypoints.length; i++) {
            let wp = waypoints[i];
            let wp_marker = this._getMarker(waypoints[i].markerId);
            let wp_letters = wp_marker[0].getLabel().text.trim().split(',');
            if (wp_letters.length == 0)
                continue;

            const dups = waypoints.filter(w => w.lng == wp.lng && w.lat == wp.lat && w.id != wp.id);
            if (dups) {
                dups.forEach((d) => {
                    let marker = this._getMarker(d.markerId);
                    let letters = marker[0].getLabel().text.trim().split(',');
                    if (letters.length > 0) {
                        wp_letters = [...new Set([...wp_letters, ...letters])];
                        marker[0].setLabel({
                            text: " ",
                            fontSize: "25px",
                            fontWeight: "bold"
                        } as google.maps.MarkerLabel);
                    }
                })
            }

            wp_marker[0].setLabel({ text: wp_letters.filter(m => m.length > 0).join(','), fontSize: "25px", fontWeight: "bold" } as google.maps.MarkerLabel);
        }
    }

    removeNumbersFromMarkers = (waypoints: Array<WaypointData>) => {
        for (let i = 0; i < waypoints.length; i++) {
            let marker = this.markers.filter((m) => {
                if (waypoints[i].markerId === m.get("id")) {
                    return true;
                }
                return false;
            });
            if (marker[0] != null) {
                marker[0].setLabel(null);
            }
        };
    }

    removeNumbersFromAllMarkers = () => {
        this.markers.forEach((marker) => {
            marker.setLabel(null);
        });
    }

    setCircle = (latLng: google.maps.LatLng, meters: number) => {
        if (!this.circle) {
            this.circle = new google.maps.Circle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#a8d0fd",
                fillOpacity: 0.35,
                map: this.map,
                center: {
                    lat: latLng.lat(),
                    lng: latLng.lng()
                },
                radius: meters
            });
        }
        else {
            this.circle.setCenter(latLng);
            this.circle.setRadius(meters);
        }
        this.map.fitBounds(this.circle.getBounds());
    };

    removeCircle = () => {
        if (this.circle) {
            this.circle.setMap(null);
            this.circle = null;
        }
    }

    togglePins = (routeId: number, show: boolean = false) => {
        for (let i = 0; i < this.markers.length; i++) {
            if (this.markers[i].get("routeId") === routeId) {
                this.markers[i].setVisible(show ? true : !this.markers[i].getVisible());
            }
        }
        let routeClusterer = this._markerClusterers.filter((mc) => {
            return mc.routeId === routeId;
        })[0];
        if (routeClusterer) {
            routeClusterer.clusterer.repaint();
        }
    }

    removeMarkersFromRoute = (routeId: number) => {
        if (routeId != null) {
            const markersToRemove = this.markers.filter((m) => {
                return m.get("routeId") === routeId;
            });
            this._removeMultipleMarkersFromClusterer(markersToRemove, routeId);

            this.markers = this.markers.filter((m) => {
                if (m.get("routeId") === routeId) {
                    m.setMap(null);
                    return false;
                }
                return true;
            });
        }
        else {
            this._searchClusterer.clearMarkers();
            this.markers = this.markers.filter((m) => {
                if (m.get("routeId") == null) {
                    m.setMap(null);
                    return false;
                }
                return true;
            });
        }
    }

    setFocusToRoute = (routeId: number) => {
        let markers = this.markers.filter((m) => {
            if (m.get("routeId") === routeId) {
                return true;
            }
            return false;
        });
        this.setFocusByMarkers(markers);
    }

    setFocusByMarkers = (markers: Array<google.maps.Marker>) => {
        if (markers.length > 0) {
            let bounds = new google.maps.LatLngBounds();
            for (var i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].getPosition());
            }
            this.map.fitBounds(bounds);
            let zoom = this.map.getZoom();
            if (zoom > 12) {
                this.map.setZoom(12);
            }
        }
    }

    setFocusToAllMarkers = () => {
        this.setFocusByMarkers(this.markers);
    }

    setClusterSizes = (minimumClusterSize: number, clusterGridSize: number) => {
        this.minimumClusterSize = minimumClusterSize;
        this.clusterGridSize = clusterGridSize;
    }

    markRouteByID = (routeID: number) => {
        this.removeRouteMarking();
        const renderer = this._directionsRenderers.find((r) => {
            return r.get("routeId") === routeID;
        });
        if (renderer != null) {
            this._highlightedPath = new google.maps.Polyline({
                path: renderer.getDirections().routes[0].overview_path,
                geodesic: true,
                strokeColor: 'red',
                strokeOpacity: 0.3,
                strokeWeight: 15
            });

            this._highlightedPath.setMap(this.map);
        }
    }

    removeRouteMarking = () => {
        if (this._highlightedPath != null) {
            this._highlightedPath.setMap(null);
            this._highlightedPath = null;
        }
    }

    markPoint = (markerID: string) => {
        const marker = this.markers.find((m) => {
            return m.get("id") === markerID;
        });
        if (marker != null && this._highlightedMarkerCircle == null) {
            this._highlightedMarkerCircle = new google.maps.Marker({
                position: marker.getPosition(),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillOpacity: 0.35,
                    fillColor: '#F8FF00',
                    strokeOpacity: 0.8,
                    strokeColor: '#000000',
                    strokeWeight: 2.0,
                    scale: 30
                }
            });

            this._highlightedMarkerCircle.setMap(this.map);
        }
    }

    removePointMarking = () => {
        if (this._highlightedMarkerCircle != null) {
            this._highlightedMarkerCircle.setMap(null);
            this._highlightedMarkerCircle = null;
        }
    }
}

interface RouteClusterer {
    routeId: number;
    clusterer: MarkerClusterer;
}

interface PinTypeConfigProps {
    iconName?: string;
    template?: string;
    dynamicApi?: {
        url: string,
        parameters: StringKeyDictionary<string>
    };
    statistics?: Array<QuickInfoStatistic>;
}

interface PinTypeConfig {
    type: string;
    props: PinTypeConfigProps;
}